export var firebaseConfig = {
    apiKey: 'AIzaSyBoUdiDtzQdC-m4nj9CPY5SvY7uKJGL71k',
    authDomain: 'matx-15ede.firebaseapp.com',
    databaseURL: 'https://matx-15ede.firebaseio.com',
    projectId: 'matx-15ede',
    storageBucket: 'matx-15ede.appspot.com',
    messagingSenderId: '348111707030',
    appId: '1:348111707030:web:70c4ca4eb3f1dbd18e1bb7',
    measurementId: 'G-806629YLNN',
}

export const auth0Config = {
    client_id: 'V9U8qYXyUKaxsqBeKJqVMiy948TemIb5',
    domain: 'dev-baracaf.us.auth0.com',
}

export const auth0M2MConfig = {
    client_id: "5j3fobVejSfpBNXFiEYFAtkuAyuaqokV",
    client_secret: "c-7JicJrEM4YZywEh044O4Nu-L5YHQIAqWskSRaPcMizbw7gx_j5fl_BHY3wxVmt",
    audience: "https://admin-portafolio-api-dev",
    grant_type: "client_credentials"
}

export const auth0AdminM2MConfig = {
    client_id: "5j3fobVejSfpBNXFiEYFAtkuAyuaqokV",
    client_secret: "c-7JicJrEM4YZywEh044O4Nu-L5YHQIAqWskSRaPcMizbw7gx_j5fl_BHY3wxVmt",
    audience: "https://dev-baracaf.us.auth0.com/api/v2/",
    grant_type: "client_credentials"
}

export const templatesSettlementLetter = {
    baracaf: 'Templates/FormatoCartaLiquidacionAnticipadaBaracafv3.pdf',
    rapido: 'Templates/FormatoCartaLiquidacionAnticipadaRapidov3.pdf'
}

export const templatesCreditSettlementLetter = {
    baracaf: 'Cartas_Finiquito/Templates/CARTA_FINIQUITO_BARACAF.pdf',
    rapido: 'Cartas_Finiquito/Templates/CARTA_FINIQUITO_RAPICREER.pdf'
}

export const backAPIUrl = {
    initialAPI: 'https://core-api.admin.baracaf.com/initial',
    originationAPI: 'https://origination-api.admin.baracaf.com/origination',
    creditosAPI: 'https://credits-api.admin.baracaf.com/creditos'
}

// export const backAPIUrl = {
//     initialAPI: 'http://localhost:8001/initial',
//     originationAPI: 'http://localhost:8002/origination',
//     creditosAPI: 'http://localhost:8003/creditos'
// }
